import { useSelector } from 'react-redux';
import path from 'path';
import { Route, Switch, useLocation, useRouteMatch } from 'react-router-dom';
import { ScreeningApp } from '@zg-rentals/screening-js';
import { URLS } from '../../../../constants/urls';
import ApplicationsTabPage from '../../../ApplicationsTabPage';
import ApplicantDetails from './ApplicantDetails';
import ApplicationSummaryContainer from './ApplicationSummaryContainer';
import { isListingRestrictedSelector } from '../../../../selectors';
import { allSharedReportsSelector } from '../../../../selectors/sharedReports';
import { DeclineApplicationPage } from '../../../DeclineApplication';
import { TREATMENT_TYPES } from '../../../../constants/treatmentTypes';
import { trackListingUserEvent } from '../../../../../client/analytics';
import { getZrmListingInfo, getZrmUserInfo } from '@zg-rentals/clickstream';
import { useListingUser } from '../../../../hooks/useListingUser';

export default function Routes() {
  const match = useRouteMatch();
  const location = useLocation();
  const { user, listing } = useListingUser();

  const isRestricted = useSelector(isListingRestrictedSelector);
  const allSharedReports = useSelector(allSharedReportsSelector);

  if (isRestricted) {
    return (
      <Switch>
        <Route component={ApplicationsTabPage} />
      </Switch>
    );
  }

  return (
    <Switch>
      <Route
        path={path.join(match.path, URLS.APPLICANT, URLS.SCREENING)}
        render={(renderProps) => {
          const { applicantId, zgAuthZone } = renderProps.match.params;
          const sharedReports = allSharedReports[applicantId];

          return (
            <ScreeningApp
              {...renderProps}
              userType="landlord"
              rootUrl={path.join(match.url, 'applicants', zgAuthZone, applicantId)}
              rootQuery={location.search}
              returnUrl={`${match.url}${location.search}`}
              proxyPath={URLS.PROXY_PATH}
              trackEvent={(basePayload) => {
                trackListingUserEvent({
                  ...basePayload,
                  ...getZrmUserInfo(user),
                  ...getZrmListingInfo(listing),
                });
              }}
              applicantId={applicantId}
              applicantZgAuthZone={zgAuthZone}
              sharedReports={sharedReports}
              RA_PASSIVE_AUTH_ENABLED={{
                loading: false,
                error: null,
                treatment: TREATMENT_TYPES.ON,
              }}
              RA_IRENE_REMOVE_SSN_FROM_IDV={{
                loading: false,
                error: null,
                treatment: TREATMENT_TYPES.CONTROL,
              }}
            />
          );
        }}
      />
      <Route path={path.join(match.path, URLS.APPLICANT)} component={ApplicantDetails} />
      <Route exact path={path.join(match.path, URLS.DECLINE_APPLICATION)} component={DeclineApplicationPage} />
      <Route path={match.path} component={ApplicationSummaryContainer} />
    </Switch>
  );
}
